<template>
  <el-popover
    placement="right-start"
    width="680px"
    trigger="hover"
    @show="handleShow"
    @hide="handleHide"
  >
    <div
      class="flex row-between"
      :style="`width: ${
        goodsInfo.factory_images.length > 0 ? 1040 : 660
      }px; height: 320px`"
    >
      <div class="flex-col" style="width: 280px">
        <div class="nr weight-700 m-b-10">
          <span>导入产品图</span>
        </div>
        <el-carousel
          v-if="goodsInfo.customized_info?.effect_images"
          trigger="click"
          height="280px"
          style="width: 280px"
        >
          <el-carousel-item
            v-for="(item, index) in goodsInfo.customized_info?.effect_images"
            :key="index"
          >
            <el-image
              class="image-280"
              :src="item ? $getImageUri(item, false, 280) : emptyImg"
              :preview-src-list="[item || emptyImg]"
              :initial-index="index"
              style="object-fit: contain"
            ></el-image>
          </el-carousel-item>
        </el-carousel>
        <el-image
          class="image-280"
          v-else
          :src="emptyImg"
          :preview-src-list="[emptyImg]"
        ></el-image>
      </div>
      <div class="flex" style="width: 360px; margin-left: 20px">
        <div class="flex-column m-r-30">
          <div class="nr weight-700 m-b-10 flex row-between">
            <span>定制产品图</span>
          </div>
          <div class="flex img-box">
            <div
              class="flex-column img-list scrollbar"
              v-if="goodsInfo.effect_images.length > 0"
            >
              <div
                class="img-list-item"
                v-for="(img, imgI) in goodsInfo.effect_images"
                :key="imgI"
                @click="goods_image = img"
              >
                <el-image
                  :src="img ? $getImageUri(img, false, 70) : emptyImg"
                  alt=""
                />
              </div>
            </div>
            <div class="img-preview">
              <el-image
                :src="
                  goods_image ? $getImageUri(goods_image, false, 300) : emptyImg
                "
                :preview-src-list="[
                  goods_image ? $getImageUri(goods_image, false) : emptyImg,
                ]"
              ></el-image>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex"
        style="width: 360px; margin-left: 20px"
        v-if="goodsInfo.factory_images.length > 0"
      >
        <div class="flex-column m-r-30">
          <div class="nr weight-700 m-b-10 flex row-between">
            <span>生产图</span>
          </div>
          <div class="flex img-box">
            <div class="flex-column img-list">
              <div
                class="img-list-item"
                v-for="(img, imgI) in goodsInfo.factory_images"
                :key="imgI"
                @click="factory_img_index = imgI"
              >
                <img
                  :src="img ? $getImageUri(img, false, 70) : emptyImg"
                  alt=""
                  style="object-fit: contain"
                />
              </div>
            </div>
            <div class="img-preview">
              <el-image
                :src="
                  goodsInfo.factory_images[factory_img_index]
                    ? $getImageUri(
                        goodsInfo.factory_images[factory_img_index],
                        false,
                        300,
                      )
                    : emptyImg
                "
                :initial-index="factory_img_index"
                :preview-src-list="goodsInfo.factory_images"
                fit="contain"
              ></el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="reference">
      <slot></slot>
    </div>
  </el-popover>
</template>
<script>
export default {
  name: "order-image-preview",
  props: {
    goods: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      goodsInfo: { effect_images: [], factory_images: [] },
      goods_image: "",
      factory_img_index: 0,
      timer: null,
    };
  },
  computed: {
    emptyImg() {
      return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAAFORJREFUeF7tXVF63CgMnnEOsu0lJpmnpidpc5KmJ2l6krZPbXqJTQ+SmbW8ZkoIhl8gbGyUl+23AwJ+6QchBN7v9E8RUAQmEdgrNoqAIjCNgBKkMev4+fPnm67rPtCw9/v9Lf33fD5/P51OX4/H41NjcESHqwSJQrSNAr9///54Op3e7ff7jxMjInI8XF9ff97GiGVGoQSRwbFKKdZqcY92cL/f3x0Ohwe0/NbLKUE2puEUUjgQPF1fX7/dGCzJw1GCJENXT0UBUrwYjK4if+FQgtRj56yeWKSgPcUbVuVI4X7z/v1wOLyXlLlWWUqQFWnOkIKiT33kaYhAlfo7nU7vj8fj91Ly1yJXCVK5puYkhQPFvUa0djslSKUEAcKypXuum3U6KyqNssrHEZDebOMt+0uqm6UEybWh7Pq1kcIe0Pl8fri5ubnLHuSKBegKsoDyaiaFA0fzbpYSZCaClAzLlhxC626WEqSgdS0YgXJHNeRZ9QeAf+iH8/n8BR12626WEgS1FLBcRaSgbF06x/hq51aN/fsXHA4Va9rNUoIwLCVU9OfPn7f7/f5DIFtWqKWomGhW7u/fv79xDhpbdrOUIFF7my5Q0WY7Sgp7FHTGwnGzWk49UYIwCbJWUtjDVDcLV7oSBMCqogjUsFJI3P7julmtZvgqQSYIskVSOKvIbdd134D5YSjSqpulBLEspKIIlNhKMUWABDdr1+JmvXmCVEiKH3OlmXPdrJ5szWX4NkuQSsKyZqWYjRQ5blaLZyJNEaSSCNTlVHvpxxHUzYrvwDZPkEpIMWxy6f2p2i4h/fr16wvzcLMpN2uTBKktAlUbKdTNiq8cpsRmCKKkwJXuHhpeXV190dQTP36rJkhtEaiaV4oQfR4fHz9RhAqlWEsZvqsjSG2kkDjVRg2zVDmK6HEODVuKZq2GIJWFZTf30DP3TKSVQ8OqCVJJBKr4qXaplYEjl+tmtZJ6Uh1BKiPFIgd4HMOWKptwJtLERaoqCFJJBGrRU20pQ8+Ro27Wa/QWI0hNpKC72kufaucYtlRddbMWJkgtEahaT7WlDD1VjrpZCxCkFlJQaFK/oBSnDtfN2nqGbzEXi4ix3+8/MfN84hrklVBS8PDa6X31l4CJE4SIwU1dYOowVlxJEUMo8HuCm7Xpi1TiBElYojPUeanaxFmFBFCIjAQdbjbDV5QgCanTiL6myigpctAL1OW6WVtOPRElyOPjI73YJ/o5MEePSopCpLDFqpv1Fw0xgiQkvKGqbv4ADwVKshzXzdpqhq8kQd50Xcd58zWkTxYpaMajlavPSH3XK6rkCiZpg1XL6rruDeeOCLlZdGNSalBd1/2o4fBWjCAETH8Se84E6J57qp3gL2d2UavPiMDiEUlRgnCXZQI651Q7pb0ZlatNCSGwpPsmTRD4UeTcQRfc8wipVcUII7BIKFmUIJzoRy5BZoiYCetXxWUisEh6vShBCACG25M1YIH9Tqa+tPrcCCxxi1GcIJyU6dQB68Z8btOso70lXpgXJwjHzephT/IrlSB1GOzcvdgEQThuVuq9ZiXI3KZZR3ubIQjDzUrah6AEoUBAHarVXsQQ6CfL21ia0mYIwgnBpuxDQIIkkS+mSP29DAJIcGczBCntZilByhjpklKbI0hJN0sJsqQpl2m7OYKUdLOUIGWMdEmpLRKEk93LCvcqQZY05TJtN0cQzj6EeyNNCVLGSJeU2iRBSrlZSpAlTblM260SpIibpQQpY6RLSm2SIBw3i3OqrgRZ0pTLtN0yQdA7IvDB3hwEGcPUdKGLTnjp7aen/hG8p/5gs5kX38tQwS+1WYJwkhfRU/WSBAHPb4go74/HI10J1T8BBJolCMfNQi9RlSBIwouQi9+XFrDLakS0ThBRN6sEQRAF+axpifygaqxasCMI/ktgLX4fxIeZtJslTRBEOQFbIHfr7ng8ij15I2h3qxGF6GCzBOG4WX3Z6Km6NEFyr++iruFqrHWBjjZPEHDzOzwDdDgc3od0JEkQofeE4QjcAra3iiabJwjDzYoamyRBEMUgFoZG4BBZLZZB9LBpF4vjZsWMTZIgUs8HLaG8LRFJCfL/06SfaI8RU2zMzVKCxBBM+53czZubm7u02nm1lCC73Y6RvBh0syQJgigGUX1s1UNkLFnG4LDUSojoYYm+zRLmtRWPRoxCBidJEHRVixnv6XR6u9aTdQeD6B4whkXK70qQETVG1Ggy3CtJEEbwYFLvaw7z+lb1JWZqJchoXhJuliRBqFsM0npJslb3KjA5zL6KKEH+EgS+IzJleNIEScjDuhBlreSgAYQieHOvikoQa+5FwBiLe90saYJQW+Ns+i32eJm9hCzhiqT49746gA5mzVgG+kOHyHdzf3Vq9k36aIy3/efSyBiDf1Ph3hIEsUjyof93LBS96vwr1KWccxVRglhUYGyMvb5wKYKYLo4u1+3pdHo3fquPvtf3fbww9XWt0SrO5DRiMdtEoARx1goEEKri8/FLEyS2sq31d0aA5DLEuVYRxB6acbEIfdDIdz4FgXVnj8TUTBzGqv1qGHMEIpQgDuwMhb0ydCUIn4qIAU5JjaX+8HvzugbSv6ZWkHEV+YZ8i9udwZQgPJNEjC8msfQqgvSxOYIw0jxehHuVIDFz/vs7A+OY0KIuqxLEAz/qZrlLvBIkZsv//56yKQ9JLjmDK0EmkEeAcd/uVYLECYJOPnFJL0oUW0UQOyhJ0Mn9FxMg8eKoC2D7wEqQuBqkLoK5LZUyUiXIhE5RN8B2s5QgYYIgxhan2GSJIqsI0udS5Ay6lRlAiVVFwLHdLCXINPRoGkmO8kocHiI20CxBuG6WEsRv3uhqnEOOsa54IqMSJKAVhmKHcK8S5DWYDAwF+LHzZjjkCFaChAmC3hEZ/N/aCUL9mzMtu1DEKmbvoomMSpAI3AhAJIKiWVdXV5Rd+yUisshmMmY11jjE3ZCptlHsYn3n/i65F0HG0OwehBTDcBHue6D+1EaQiVuJxV+ARwyLa/ic8lIpKMg4WicI5GZRuHe3232tiSAAuYusJmhwg2Pw3LJSiYxKEAB5BCQK9+73+8+1EATcD9HoRVcTgJQA4jJFJFYRRPdNryCkKtTYyPftb/d9XHoPknjmkL2aLLQpD8Gdvd9TggCTFUPxNBu/WYogOa+gmHOEvv8PFLIGYHlVpFQaSUpfTJ3c2V0JAqKPAAWKyp7VfO2kvH4S6C97NRHEB4QRLpaFNzKuXBLCI7EKLvKqSaijqJsFDDZLYRPkgF5jAfpmF4H3JokuHbM76cVzDFgJAuLOcLNiEkUJMkPEKLia1LQpD62IdJAbU4zvdyUIAzUELECcGEGE+gN02R/pWgk5hvGlHh4iGOesUAj4vjLVuVjUSaHZOpsgApvxVL1cVhPBFTW1L9x67H0VNaAEYcAsZBRZBKlg1h72Jv1B3C3ysAUD3uJFU1YRJQhTLQhgEZHJBBEMFDBHvZni7ERGRN/qYln2IeBmJRGk9kjRWijEXUWUIEzNCrg4LIIsuN9gIrOe4pwUFCVIgl7Rz7VNiIYJInz4lzDSbVbhJDIqQRJsINPdgQgisFIljKydKugqogRJsIlM44UIkrlKJYyquSqQHpQgCXaRGe6FFKMESVAMs0qflBk9b1OCMEE1xRHgcvYgSpBExTCqKUEYYHGLZrhZuoJwwS5UXglSCFgSm+FmKUEK6oUjWgnCQSuhbKKbpQRJwLpEFSVICVQtmYmpH0qQwnpBxStBUKQSyyW6WUqQRLylqylBpBH1yEtws5QgM+gFaUIJgqCUWSYheVEJkom5VHUliBSSATkJbhZEEJI7Q/ebbuJ4PNLdluAf4iFoursAiJYIiCAxxenv8yCgBBHAmelmKUEEMJ9LhBJEAGnmqboSRADzuUQoQYSQRoAcm1KCCGE+hxhEr7oHATTBcLOUIACetRRRgghpguFmKUGEMJ9DjBJECGVGuFcJIoT5HGKUIIIoI2Dan40WbFpFFUIA0anuQUDwweRFXUFAPGsopgQR1IISRBDMSkQpQQQVoQQRBLMSUUoQQUWgBOnftKUPfurfChAAPqm30z0IqEiQIKA0LbYWBJQgoKaUICBQGyumBAEVyjgsBCVqsTUgoAQBtcQ4LAQlarE1IHA6nd4id0skxxJ98U6yMUlZSNRDsj2VtTwCyM1E6V6umSAfz+fzF2lAVF6dCKCPYEv3frUEISAYmb3SuKm8GRHgfEZBulurJoiSRNocqpR337tWn5fq2eoJQsCNX4eij13+03/6Sx9hWMqahNrtDw3pG4c/jsfj4ge9myCIkF5UjCLwCgEliBqFIhBAQAmi5qEIKEHUBhSBNAR0BUnDTWs1goASpBFF6zDTEFCCpOGmtRpBQAnSiKJ1mGkIKEHScNNajSCgBGlE0TrMNASUIGm4aa1GEFCCNKJoHWYaAkqQNNy0ViMIKEEaUbQOMw0BJUgablqrEQSUII0oWoeZhoASJA03rdUIAkqQRhStw0xDoGqC0AuKz8/P3+d+CykNSq21RQSqJYj9emJ/z/zh5ubmbosK2OKY6I2A3W5n3gZ44k5wo+6HJ53ofvrhcHi/FE7VEsR+GK7Ei3pGiV3XvSPwa3kkIGYIv379WuwtsK7rfhwOh4dYH+23k1MmN7v+kk/+DASNDXaJ3+2nRbkAj+D+Y/ptXjnpum6Y0fpPItz6xjSliJFIs8MwNev2b4GdZ+/M2CCqCyWIoIZGMnxzRNpP9zwhzV1fX7+lcgkGNMinb4n43LglHqcLzZoJ40Pgg8ooQSCYZAtJvdRu3m21DOhpfF9p+O/oz/55fn42hIN841oJghireS8McYtCWjWYIm2SHF1BBDnibOh2XdeRjz2sIPTcvWXQwVbNI2NGmVJP5ZOyT6fTsE9B/+yvJZFRofVMuZCvzzFWax9HD7G9526WTX84bSpBuNpmlHdWk8uTkzaJYq/tSROE0f2hqD2GEhtM1FjtIEduP9A2DVa6gnCtBixvK9V+6p4iN+OsHP2089IEyTWOGFSIsXrcwvuYXPt3N6KHtGnXz8VAo1gebdlKdd2jtRKkH6b4w8sxY5XY07l7jVibrjqVIJzpCCxrR2dcv713ESg0S/uSJ9+Xa43PboeHya04nU5QBMx0kTbzuS+Jh4gOQhEsFjJWlxyEAdqmHf5WgvxFrZpzkJzwpVFo7uyZ66sTrNZqV+SzxVMEmfiwKbSCxfYrOSsITWr95MYKVNDZlRXogOr3h8lfU4MQoUmkJoJ8CnT0o5W68Mqf7l2yPxTKdIxkyu8e/j+RwV2NjBx01vWVswlSIgPAZ6x2m9QnmjAsA5skyRgG/mJWj6kJIpMgOXDCdaWilm6D1RAkhAS6B7ENZep7dtZKBc2usIbGgo+Pj/8aMs9BEOdbjRTOvaNIn7NRfzVWK9/JhNS/T+U8KUG4VjBz+RBBaBY0S6sxztCB1gwEuaSClPjopGushgi+2d9ZUQfykMvTdd0HCiBYagxOFjkEoX49Pz/P8YUo6OCXa7qLryDmjOPq6uqSXkJfijIDGf3RyybdGqCdjnJPock+8XBIWQkttwhBcvcyXCVEyr8wXp+xEhGmTsudT2aTP/8ijcesOKE+5BAEPX0XxkxM3OIE8cTs2YMjQtBpt/G7Q67NFgkSAowIst/vP9mn+/bKgWQxK0HYJilXYWK2NrlT5BZQLpVZQajhe9pM0z/sNBRr9Zj0pakOgyApaeXsJEsAyQc79IwY67hqkBtlBzeGpsbghJvRPITPKVxOmLrZCkib9jjsSU9XEEDDsRmOfg+F6GKbdDtEHNsYIwRJHRKnH7lt2IZnCEETyUQ6/xAqNUSzCBQ6YR+SPJ+fn+/6PQsFHoboGHJxTQmSqt3EerFNurXpjEamShEk9/QYhcaezWnG7/drUyvdQIrQ+YDZ/+33+w90X8YllyEEdwVxws5RnaBjX6Lc4nsQZNDkhtEm3rf8m/qhjSrSRm4ZO7xrBwnsbODz+fw59zDLNlaSZ2b3sf+GFMMnlMc7/a9cpqmxmvR4s58bM4ApZDxE5tAVxDksfXXelIJ1qYPAWF+qJchocLH+5/z+wrfPEeTuo+zwrvTVYddYzQ1KN0XGc7J+uR9j9hoU8kUIm0OQHFztuoasUvJQOTUTpPTVUrGl354x3Vm2NEGmFO2ergcMYiBO6GEEJQhKpxnLGaWMCXdfpZq2fHYRgrirhzvTLUUQwsu4TPRvcpt8+wzEdeISxHY3e/nDGVWK/uzLc7qCOAiW2Ew7h2YiBIkl+i1JEJ9Rmkcorq6ubs1NyfP5TIl+k5m/CQS5rP6xqGKIOE7aDt2IhLOTUwjpq7MGF0vEkM2Mam1qs+W6bozPGFIJQqFS3yFeyFjNk0BT5xmpRsMhiLv3yUm3UYIENOZGa1KV69R7Yw4UaenPufvhOeD0ykshiCP7xS3KkLHa5zDWuJM350ZGKkHQqNeUbpUgAEGEiOETk0wQ66miy+uB5tkht6FcgrhJiFPG6mbnArhdnjuiFYfKT4XROQSZCncD/XlVRAmyQoI4+5hhBKENZApBQoeOMWO1kz9DG/Mp6H2JnrE2jSzXvcrZf5BMJQhGkOSZ3hWfu0nnkoPazyWI6wqixuobO23MR0JPRrR8ewa0zVjAgruKKEFWRBBfUiUSenQIAkViQtd2UWNFjNGNaE3dyUfa9NyHvxN4sM6+fAZhh4ybU0ajWABadvKdKY6Qg8q6aRfIS+X2Ztt1eezzIUokBLqfXSSWrOhZWaPPMyGd0hUEWEF8d8cRcH1lnMcAoq6bZzMe3XN4Nukf7YRCc/DpezFyfGn+RYq66/JMRKpSIWHVm4pKOdd+g3syToNKEIAgHECZZYOPGXiupZL4y51vtC33YQS03ljuVR9rI4hLDomXYQxGShCMIJfHp5nG5S1upXRPEiTnCR1fo5Fbfb4qL+5v2AVsF8v3RpgERh4Zw70R3wri3nufCnen9EsJghEk6gqh4HOiWNa+g71qTPXH+taIffPQLR7MsEU2zCgeaLlYmwYrdF/GaFc36VNg0cxEv0l+o9BO3ovJlfp0AGoMaDmKFo1loVR1VG6oHNKm/bqMRJskw2qXbpzOnodFfag2iiUFsspRBHIQUILkoKd1N4/AfxwtnPXNFlKSAAAAAElFTkSuQmCC";
    },
  },
  methods: {
    handleShow() {
      this.goodsInfo = this.goods;
      if (this.goodsInfo.effect_images.length > 0) {
        this.goods_image = this.goodsInfo.effect_images[0];
      }
      if (this.goodsInfo.factory_images.length > 0) {
        this.factory_img = this.goodsInfo.factory_images[0];
      }
    },
    refreshEffect(goods) {
      let sku_list = [
        {
          item_id: goods.item_id,
          model_item_id: goods.model_item_id,
          spec_value_str: goods.spec_value_str,
          spec_value_ids: goods.spec_value_ids,
        },
      ];
      this.$post("model.modelDesign/addDesignTask", {
        id: goods.design_id,
        sku_list: sku_list,
      }).then((res) => {
        if (res.code == 1) {
        }
      });
    },

    handleHide() {
      clearInterval(this.timer);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-carousel {
  .el-carousel__button {
    background-color: var(--color-primary);
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  .is-active {
    .el-carousel__button {
      background-color: var(--color-primary);
    }
  }
}

.img-box {
  .img-list {
    height: 280px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 70px;

    .img-list-item {
      margin-bottom: 5px;
      cursor: pointer;
      width: 65px;
      height: 65px;
      border: 1px solid #eee;

      &:hover {
        border: 1px solid var(--color-primary);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .img-preview {
    width: 280px;
    height: 280px;
    padding: 5px;
    border: 1px solid #eee;
    margin-left: 10px;

    > div {
      width: 270px;
      height: 270px;
    }

    .el-image {
      width: 270px;
      height: 270px;
    }
  }
}
</style>
